import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import React from "react"

import {
  DragHandleContext,
  useDragHandleValue
} from "../../../../../../../components/DragHandle.tsx"

interface SortableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  /** Taken from the record rather than AntD's data-row-key, which is an
   *  internal detail and is not guaranteed to reach a custom row component. */
  id: string
}

export function MilestoneSortableRow({ id, ...props }: SortableRowProps) {
  const { setNodeRef, transform, transition, isDragging, ...sortable } =
    useSortable({ id })

  const handleValue = useDragHandleValue(sortable)

  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging ? { position: "relative", zIndex: 9999, opacity: 0.4 } : {})
  }

  return (
    <DragHandleContext.Provider value={handleValue}>
      <tr {...props} ref={setNodeRef} style={style} />
    </DragHandleContext.Provider>
  )
}
